export const BOOKING_VALID_DURATION = 5 * 60
